import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ConditionComponent } from './condition.component';

const routes = [
    {
        path     : 'condition',
        component: ConditionComponent
    }
];


@NgModule({
    declarations: [
        ConditionComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        FuseSharedModule,
    ],
})

export class ConditionModule
{
}
